<ng-container *notInPopulation="[populations.Suite, populations.Pts]">
  <div class="full-page-container">
    <fgb-banner [title]="'games.page.title' | translate"></fgb-banner>

    <div class="d-block d-lg-none">
      <fgb-page-header [pageTitle]="'games.page.title'" [backButtonLink]="'/'"></fgb-page-header>
    </div>

    <div class="container">
      <div *ngFor="let card of gameCards" class="card">
        <div class="card-header">
          <img alt="card.title" [src]="card.image" />
        </div>
        <div class="card-body">
          <h3 class="title">{{ card.title }}</h3>
          <p class="description">{{ card.description }}</p>
          <button class="btn" (click)="navigateByURL(card.route)">{{ card.buttonLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *inPopulation="[populations.Suite, populations.Pts]">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
